module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-cafe-3.99a1e62c.jpg";